package cz.lhoracek.mapl.ui.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.SwipeToDismissBox
import androidx.compose.material3.SwipeToDismissBoxValue
import androidx.compose.material3.rememberSwipeToDismissBoxState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DismissibleEndToStartItem(
    resetSignal: Boolean,
    onResetHandled: () -> Unit,
    onDismissed: () -> Unit,
    backgroundContent: @Composable RowScope.() -> Unit,
    content: @Composable RowScope.() -> Unit,
) {
    var swipeEpoch by remember { mutableIntStateOf(0) }

    LaunchedEffect(resetSignal) {
        if (resetSignal) {
            swipeEpoch++
            onResetHandled()
        }
    }

    key(swipeEpoch) {
        val dismissState = rememberSwipeToDismissBoxState(
            positionalThreshold = { it * 0.4f },
        )
        val isDismissed = dismissState.currentValue == SwipeToDismissBoxValue.EndToStart
        LaunchedEffect(dismissState.currentValue) {
            if (dismissState.currentValue == SwipeToDismissBoxValue.EndToStart) {
                onDismissed()
            }
        }
        SwipeToDismissBox(
            modifier = Modifier.fillMaxWidth(),
            state = dismissState,
            enableDismissFromStartToEnd = false,
            backgroundContent = backgroundContent,
            content = {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .alpha(if (isDismissed) 0f else 1f),
                    content = content,
                )
            },
        )
    }
}
